const observer = new MutationObserver(() => {
  if(document.querySelector('.loyaltylion-info-tier') && document.querySelector('.loyaltylion-info-tier .lion-tier-compare__header-cell--current')) {
    document.querySelector('.loyaltylion-tier').textContent = capitalizeFirstLetter(document.querySelector('.loyaltylion-info-tier .lion-tier-compare__header-cell--current').textContent)
  }
})

observer.observe(document.querySelector('.loyaltylion-info-tier'), {
  subtree: true,
  childList: true,
})

function capitalizeFirstLetter(text) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function handleStylesWidth() {
  if(document.querySelector('.hn-reward-image-profile')) {
    const section = document.querySelector('.hn-reward-image-profile')
    let maxWidthElement = null
    let maxWidth = 0

    if(section.classList.contains('logged')) {
      Array.from(document.querySelectorAll('.item-number')).forEach(item => {
        const itemWidth = item.getBoundingClientRect().width
        if (itemWidth > maxWidth) {
          maxWidth = itemWidth
          maxWidthElement = item
        }
      })

      Array.from(document.querySelectorAll('.item-number')).forEach(item => {
        item.style.width = `${maxWidthElement.getBoundingClientRect().width}px`
      })
    }
  }
}

handleStylesWidth()

window.addEventListener('resize', function() {
  handleStylesWidth()
})